module.exports = __webpack_public_path__ + "static/media/a.e098fbd5.jpg";